// src/shared/dates.js — датите в български формат (копие от app.js, Фаза 3).
// ВНИМАНИЕ: контрактът dataset.iso е протокол с всички save-функции — пази се.

import { el, input } from './dom.js';
import { toast } from './toast.js';

// „Днес" по МЕСТНИЯ календар — toISOString() дава UTC и около полунощ
// бележи вчерашния/утрешния ден (капанът от календара, правило (е)).
export function localTodayIso() {
  const n = new Date();
  const p = (x) => (x < 10 ? '0' : '') + x;
  return n.getFullYear() + '-' + p(n.getMonth() + 1) + '-' + p(n.getDate());
}

export function isoToBg(iso) {
  if (!iso) return '';
  const p = String(iso).slice(0, 10).split('-');
  return p.length === 3 ? p[2] + '.' + p[1] + '.' + p[0] : '';
}

export function bgToIso(s) {
  s = String(s == null ? '' : s).trim();
  if (!s) return '';
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return s.slice(0, 10);
  m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/);
  if (m) return m[3] + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0');
  return '';
}

// Разчита датата, КАКТО Я ПИШЕ ЧОВЕК (ПРОМТ-19, т. 1). Връща ISO, '' при
// празно и null при неразбран текст или несъществуваща дата (31.02).
// Приема: 5.10.2026, 05.10.2026, 5.10.26 (→ 2026), 5/10/2026, 5-10-2026,
// 05102026, 051026 и ISO. Отделно от bgToIso, което ползва вносът от Excel —
// там правилата не се сменят между другото.
export function parseBgDate(s) {
  s = String(s == null ? '' : s).trim();
  if (!s) return '';
  let d, m, y;
  let r = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (r) { y = +r[1]; m = +r[2]; d = +r[3]; }
  else if ((r = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{2}|\d{4})$/))) { d = +r[1]; m = +r[2]; y = +r[3]; if (r[3].length === 2) y += 2000; }
  else if ((r = s.match(/^(\d{2})(\d{2})(\d{4})$/))) { d = +r[1]; m = +r[2]; y = +r[3]; }
  else if ((r = s.match(/^(\d{2})(\d{2})(\d{2})$/))) { d = +r[1]; m = +r[2]; y = 2000 + +r[3]; }
  else return null;
  // Проверка по календара: Date(2026, 1, 31) прескача в март — значи няма такъв ден.
  const t = new Date(y, m - 1, d);
  if (m < 1 || m > 12 || d < 1 || t.getFullYear() !== y || t.getMonth() !== m - 1 || t.getDate() !== d) return null;
  const p = (x) => (x < 10 ? '0' : '') + x;
  return y + '-' + p(m) + '-' + p(d);
}

const DATE_MSG = 'Не разбрах датата — напишете я като 05.10.2026';
let _dateMsgSeq = 0;

// Червено поле + обяснение под него (свързано с aria-describedby). Поправено
// поле ги маха. Ползва се и при излизане от полето, и от dateInputsValid.
function markDate(elx, ok) {
  // Връзката е в самото поле — полето може още да не е в документа.
  const old = elx._dateMsg || null;
  if (ok) {
    elx.removeAttribute('aria-invalid');
    elx.classList.remove('bad');
    if (old) old.remove();
    elx._dateMsg = null;
    elx.removeAttribute('aria-describedby');
    return;
  }
  elx.setAttribute('aria-invalid', 'true');
  elx.classList.add('bad');
  if (!old) {
    const id = 'date-msg-' + (++_dateMsgSeq);
    elx._dateMsg = el('div', { class: 'date-msg', id, role: 'alert', text: DATE_MSG });
    elx.insertAdjacentElement('afterend', elx._dateMsg);
    elx.setAttribute('aria-describedby', id);
  }
}

// Текстово поле за дата (показва ДД.ММ.ГГГГ, пази ISO в dataset.iso).
// Неразбраният текст оставя dataset.iso ПРАЗНО — затова формите викат
// dateInputsValid() преди запис: иначе сървърът тихо слага днешна дата.
export function dateInput(iso) {
  const elx = input({ type: 'text', value: isoToBg(iso), placeholder: 'дд.мм.гггг', maxlength: '10', inputmode: 'numeric' });
  elx.dataset.iso = bgToIso(iso);
  elx.dataset.dateInput = '1';
  elx.addEventListener('input', function (e) {
    // Автоматичните точки — САМО когато човекът пише само цифри
    // (01072026 -> 01.07.2026). Написаната от него точка (5.10.2026) остава:
    // старото „махни всичко освен цифрите" правеше от нея 51.02.026.
    // Точките, сложени от нас, не бива да спират следващата: при писане
    // цифра по цифра след „01.01" идваше „01.0120206" (Макс, 17.10.2026) —
    // проверката искаше САМО цифри. Сега се преподрежда и стойност, чиито
    // точки са точно на нашите места (след деня и месеца).
    const deleting = e && e.inputType && String(e.inputType).indexOf('delete') === 0;
    const v = elx.value;
    const ownDots = /^[\d.]+$/.test(v) && !v.endsWith('.') && [...v].every((ch, i) => ch !== '.' || i === 2 || i === 5);
    if (!deleting && ownDots) {
      const d = v.replace(/\./g, '').slice(0, 8);
      let out = d.slice(0, 2);
      if (d.length > 2) out += '.' + d.slice(2, 4);
      if (d.length > 4) out += '.' + d.slice(4, 8);
      if (out !== elx.value) elx.value = out;
    }
    const i = parseBgDate(elx.value);
    elx.dataset.iso = i || '';
    // Докато пише, грешката се маха веднага щом датата стане вярна; нова
    // грешка се показва чак при излизане — не по средата на писането.
    if (i !== null && elx.getAttribute('aria-invalid')) markDate(elx, true);
  });
  elx.addEventListener('blur', function () {
    const i = parseBgDate(elx.value);
    elx.dataset.iso = i || '';
    if (i) elx.value = isoToBg(i);
    markDate(elx, i !== null);
  });
  return elx;
}

// ЕДНАТА проверка преди запис: поле за дата с текст, но без разбрана дата,
// спира „Запази" и получава фокус. Празно поле минава (както досега).
export function dateInputsValid(root) {
  let first = null;
  (root ? [...root.querySelectorAll('input[data-date-input]')] : []).forEach((elx) => {
    const ok = parseBgDate(elx.value) !== null;
    if (ok) elx.dataset.iso = parseBgDate(elx.value) || '';
    markDate(elx, ok);
    if (!ok && !first) first = elx;
  });
  if (first) { try { first.focus(); } catch (e) {} return false; }
  return true;
}

// Проверката преди запис за цяла форма: от кое да е поле на формата стига
// до прозореца (.modal) или екрана (main) и проверява ВСИЧКИ дати в него.
// Един ред в началото на всеки save — затова е тук, а не преписан десет пъти.
export function guardDates(anyField) {
  const root = (anyField && anyField.closest && (anyField.closest('.modal') || anyField.closest('main'))) || document.body;
  if (dateInputsValid(root)) return true;
  toast('Не разбрах една от датите — поправете червеното поле.', true);
  return false;
}
